import { defineStore } from 'pinia'
import api from '@/utils/axios'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    logo: '' as string,
    name: '' as string,
  }),
  actions: {
    async fetchSettings() {
      try {
        const res = await api.get('/api/auth/Infos')
        if (res.data) {
          this.logo = res.data.logo || ''
          this.name = res.data.name || ''
        }
      } catch (err) {
        console.error('Failed to load app settings', err)
      }
    },
  },
})
